import React from "react";
import { Pagination, Select, MenuItem, Grid, Typography } from "@mui/material";

const PayInPagination = ({ currentPage, pageSize, totalRecords, handlePageChange, handlePageSizeChange }) => {
  return (
    <>
            {/* Pagination */}
            <Grid container spacing={2} justifyContent="space-between" alignItems="center" style={{marginTop:'1%'}}>
                <Grid item>
                    <Select variant="outlined" value={pageSize} onChange={handlePageSizeChange}>
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={25}>25</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                    </Select>
                    <Typography display="inline" style={{ marginLeft: 8 }}>
                        Showing {currentPage * pageSize + 1} to {Math.min((currentPage + 1) * pageSize, totalRecords)} out of {totalRecords} records
                    </Typography>
                </Grid>
                <Grid item>
                    <Pagination count={Math.ceil(totalRecords / pageSize)} color="primary" page={currentPage + 1} onChange={handlePageChange} />
                </Grid>
            </Grid>
      </>
  );
};

export default PayInPagination;
